import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { AppCard } from '../general';
import { VoxVendorBreakdownItem } from '../../models/reporting/reporting';

interface VoxVendorTableProps {
  title: string;
  vendors: VoxVendorBreakdownItem[];
  onVendorClick?: (vendorId: number) => void;
}

const formatEngagementTime = (ms: number): string => {
  if (ms < 1000) return `${Math.round(ms)} ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)} s`;
  if (ms < 3600000) return `${(ms / 60000).toFixed(1)} min`;
  return `${(ms / 3600000).toFixed(1)} hr`;
};

const VoxVendorTable = (props: VoxVendorTableProps): JSX.Element => {
  const { title, vendors, onVendorClick } = props;

  const completionRateBody = (rowData: VoxVendorBreakdownItem) => {
    if (rowData.completionRate == null || isNaN(rowData.completionRate)) return <span className="text-gray-400">N/A</span>;
    const severity = rowData.completionRate >= 95 ? 'success' : rowData.completionRate >= 80 ? 'warning' : 'danger';
    return <Tag severity={severity} value={`${rowData.completionRate}%`} className="text-xs" />;
  };

  const engagementTimeBody = (rowData: VoxVendorBreakdownItem) => {
    if (!rowData.supportsUserInteraction) return <span className="text-gray-400">N/A</span>;
    if (rowData.avgTimeToUserEngagementMs == null) return <span className="text-gray-400">--</span>;
    return <span>{formatEngagementTime(rowData.avgTimeToUserEngagementMs)}</span>;
  };

  const vendorBody = (rowData: VoxVendorBreakdownItem) => {
    if (onVendorClick) {
      return (
        <span
          className="text-blue-600 hover:underline cursor-pointer font-medium"
          onClick={() => onVendorClick(rowData.vendorId)}
        >
          {rowData.vendor}
        </span>
      );
    }
    return <span className="font-medium">{rowData.vendor}</span>;
  };

  return (
    <AppCard title={title}>
      <DataTable value={vendors} size="small" stripedRows emptyMessage="No data">
        <Column field="vendor" header="Vendor" body={vendorBody} />
        <Column field="count" header="Total" sortable />
        <Column field="successCount" header="Success" sortable />
        <Column field="failedCount" header="Failed" sortable />
        <Column field="inProgressCount" header="In Progress" sortable />
        <Column field="canceledCount" header="Canceled" sortable />
        <Column header="Completion Rate" body={completionRateBody} />
        <Column header="Avg Time to Engagement" body={engagementTimeBody} />
      </DataTable>
    </AppCard>
  );
};

export default VoxVendorTable;
